export interface VenueOpenDay {
    date: string
    open: boolean
}

export class VenueOpenDaysCalendar {

    private days = new Map<string, VenueOpenDay>()
    private requestedMonths = new Set<string>()

    private static monthKey(year: number, oneIndexedMonth: number): string {
        return `${year}-${oneIndexedMonth}`
    }

    static dateKey(year: number, oneIndexedMonth: number, day: number): string {
        return `${year}-${String(oneIndexedMonth).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    }

    private static dateFromKey(date: string): Date {
        const [year, month, day] = date.split('-').map(Number)
        return new Date(year, month - 1, day)
    }

    isMonthAvailabilityKnown(year: number, oneIndexedMonth: number): boolean {
        return this.requestedMonths.has(VenueOpenDaysCalendar.monthKey(year, oneIndexedMonth))
    }

    markMonthRequested(year: number, oneIndexedMonth: number): void {
        this.requestedMonths.add(VenueOpenDaysCalendar.monthKey(year, oneIndexedMonth))
    }

    unmarkMonthRequested(year: number, oneIndexedMonth: number): void {
        this.requestedMonths.delete(VenueOpenDaysCalendar.monthKey(year, oneIndexedMonth))
    }

    addDays(days: VenueOpenDay[]): void {
        days.forEach(day => this.days.set(day.date, day))
    }

    isDateClosed(year: number, oneIndexedMonth: number, day: number): boolean {
        if (!this.isMonthAvailabilityKnown(year, oneIndexedMonth)) {
            return false
        }
        const openDay = this.days.get(VenueOpenDaysCalendar.dateKey(year, oneIndexedMonth, day))
        return openDay !== undefined && !openDay.open
    }

    firstOpenDateAfter(date: Date): Date | null {
        const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate())
        return Array.from(this.days.values())
            .filter(day => day.open)
            .map(day => VenueOpenDaysCalendar.dateFromKey(day.date))
            .filter(openDate => openDate.getTime() > startOfDay.getTime())
            .sort((a, b) => a.getTime() - b.getTime())[0] ?? null
    }
}
